<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="id ? '编辑短剧' : '创建短剧'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 剧名 -->
      <a-form-item
        label="剧名"
        name="playlet_name"
        :rules="[{ required: true, message: '请输入'  }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.playlet_name"
        />
      </a-form-item>
      <!-- 关联短剧 -->
      <a-form-item
        label="关联短剧"
        name="original_drama_name"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.original_drama_name"
        />
      </a-form-item>
      <!-- 总集数 -->
      <a-form-item
        label="总集数"
        name="seq_count"
        :rules="[{ required: true, validator: validatortotal_ep }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.seq_count"
          suffix="集"
        />
      </a-form-item>
      <!-- 片源 -->
      <a-form-item
        label="片源"
        name="film_type"
        :rules="[{ required: true, message: '请选择'  }]"
      >
        <a-select
          v-model:value="formState.film_type"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in FilmTypesDy" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 账号 -->
      <a-form-item
        label="账号"
        name="account_id"
        :rules="[{ required: true, message: '请选择'  }]"
      >
        <a-select
          v-model:value="formState.account_id"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in accounts" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 上架日期 -->
      <a-form-item
        label="上架日期"
        name="publish_date"
        :rules="[{ required: true, message: '请选择'  }]"
      >
        <a-date-picker
          class="form-input"
          v-model:value="formState.publish_date"
          placeholder="请选择"
        />
      </a-form-item>
      <!-- 成片供应商 -->
      <a-form-item
        label="成片供应商"
        name="film_supplier_id"
        :rules="[{ required: true }]"
      >
        <a-select
          class="form-input"
          show-search
          v-model:value="formState.film_supplier_id"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in supplierListFilm"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 分成比例 -->
      <a-form-item
        label="分成比例"
        name="cash_rate"
        :rules="[{ required: true, validator: validatorCashRate }]"
      >
        <a-input
          class="form-input"
          v-model:value="formState.cash_rate"
          placeholder="请输入"
          suffix="%"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import dayjs from 'dayjs'
import { supplierAll, playletEdit, playletAll, accountAll } from '@/api/copyright'
import { FilmTypesDy } from '@/utils/constantList'

// emit
const emit = defineEmits(['success'])
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// id
let id = ref(null)
// 账号列表
let accounts = ref([])
// 剧列表
let playlets = ref([])
// 成片供应商列表
let supplierListFilm = ref([])
// 表单
let formState = reactive({
  // 剧名
  playlet_name: undefined,
  // 关联短剧
  original_drama_name: undefined,
  // 总集数
  seq_count: undefined,
  // 片源
  film_type: undefined,
  // 账号
  account_id: undefined,
  // 上架日期
  publish_date: undefined,
  // 成片供应商
  film_supplier_id: undefined,
  // 分成比例
  cash_rate: undefined,
})

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // 赋值
  nextTick(() => {
    // id
    id.value = params.id
    // 剧名
    formState.playlet_name = params.playlet_name
    // 关联短剧
    formState.original_drama_name = params.original_drama_name
    // 总集数
    formState.seq_count = params.seq_count
    // 片源
    formState.film_type = params.film_type
    // 账号
    formState.account_id = params.account_id
    // 上架日期
    formState.publish_date = params.publish_date ? dayjs(params.publish_date) : undefined
    // 成片供应商
    formState.film_supplier_id = params.film_supplier_id
    // 分成比例
    formState.cash_rate = params.cash_rate
    // 获取选择项列表
    getSelectList()
    // 获取供应商列表
    getSupplierAll()
  })
}

// 获取选择项列表
function getSelectList () {
  playletAll().then(res => {
    const { code, data } = res
    if (code === 0) {
      playlets.value = data
    }
  })
  accountAll().then(res => {
    const { code, data } = res
    if (code === 0) {
      accounts.value = data
    }
  })
}


// 获取供应商列表
function getSupplierAll (type) {
  supplierAll({
    friendship_status: 1,
    page: 1,
    page_size: 10000,
    // 1摄制 2剧本 3成片
    type: 3
  }).then(res => {
    const { code, data } = res
    if (code === 0) {
      supplierListFilm.value = data
    }
  })
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    // 重置
    RefForm.value.resetFields()
    id.value = undefined
    visible.value = false
  }
}

// 效验 - 总集数
function validatortotal_ep (rule, value) {
  if (!value) {
    return Promise.reject('请输入${label}')
  } else if (!Pub.REG_IS_INTEGER(value)) {
    return Promise.reject('必须为正整数')
  }
  return Promise.resolve()
}
// 效验 - 分成比例
function validatorCashRate (rule, value) {
  if (!value) {
    return Promise.reject('请输入${label}')
  } else if (!Pub.REG_IS_NUMBER(value)) {
    return Promise.reject('必须为正数')
  } else if (Pub.CHECK_NUMBER_DECIMAL(value, 2)) {
    return Promise.reject('最多 2 位小数')
  }
  return Promise.resolve()
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const params = {
      id: id.value,
      ...formState,
      publish_date: formState.publish_date.format('YYYY-MM-DD')
    }
    playletEdit(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        // 更新父组件
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
  width: 118px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.upload-item-select {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
.upload-item-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 18px;
  color: #8D8D8D;
  cursor: pointer;
  opacity: 0;
}
.form-upload-item:hover .upload-item-delete {
  opacity: 1;
}
.form-input {
  width: 100%;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
</style>